import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useDependencies } from "./useDependencies";
import { useDocumentationArea } from "./useDocumentationArea";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";

export const useDeleteDocumentationAreaActorUser = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();
  const { documentationArea, selectedActorId } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();

  if (!documentationArea) {
    throw new DocumentationAreaNotFoundError();
  }

  const actorId = selectedActorId ?? documentationArea.getActor().getId();
  const { mutate, isPending } = useMutation({
    mutationFn: async (userLinkId: string) =>
      documentationAreaController.deleteActorUser(
        token,
        documentationArea.getId(),
        actorId,
        userLinkId,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["DocumentationArea", documentationArea.getId()] });
    },
  });

  return { deleteActorUser: mutate, isPending };
};
